<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'SettingLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '场次管理'
            },
            {
              key: '2',
              title: '申请办培训'
            },
            {
              key: '4',
              title: '送培场次'
            },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/huiyi/SaiquList':
                return '1'
              case '/huiyi/SaiquApplyList':
                return '2'
              case '/songpei/SaiquList':
                return '4'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/huiyi/SaiquList')
                break
              case '2':
                this.$router.push('/huiyi/SaiquApplyList')
                break
              case '4':
                this.$router.push('/songpei/SaiquList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
